import { render, staticRenderFns } from "./SavedLeadList.vue?vue&type=template&id=3b5011dc&"
import script from "./SavedLeadList.vue?vue&type=script&lang=js&"
export * from "./SavedLeadList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports